import * as React from 'react';
import { ButtonTertiary } from 'ui';
import styles from './add-filters-button.scss';

export interface AddFiltersButtonProps {
  title?: string;
  onOpen: () => void;
}

export const AddFiltersButton = (props: AddFiltersButtonProps) => {
  return (
    <div className={styles.addFiltersButton}>
      <ButtonTertiary classNames="btn-block" onClick={props.onOpen}>
        {props.title}
      </ButtonTertiary>
    </div>
  );
};
